import { Paragraph, ImageRun, TextRun, AlignmentType } from '@skills/docx-export.jsx';
import { RHSR_LOGO, VSR_LOGO } from '@generated/components/AdGuide';

let rhsr: Uint8Array | null = null;
let vsr: Uint8Array | null = null;

async function load(url: string) {
  try { const res = await fetch(url); return new Uint8Array(await res.arrayBuffer()); }
  catch (e) { console.error('[logo] could not load', url, e); return null; }
}

/** Fetch both square logos (Red Hook + Village) once so Word exports can embed them. */
export async function preloadLogo() {
  const [a, b] = await Promise.all([rhsr ? rhsr : load(RHSR_LOGO), vsr ? vsr : load(VSR_LOGO)]);
  rhsr = a; vsr = b;
}

/** Right-aligned paragraph with the RHSR and VSR logos side by side (empty list if neither loaded). */
export function logoBlock(): unknown[] {
  const runs: (ImageRun | TextRun)[] = [];
  if (rhsr) runs.push(new ImageRun({ type: 'png', data: rhsr, transformation: { width: 80, height: 80 }, altText: { title: 'Red Hook Star-Revue', description: 'Red Hook Star-Revue logo', name: 'RHSR' } }));
  if (rhsr && vsr) runs.push(new TextRun('   '));
  if (vsr) runs.push(new ImageRun({ type: 'jpg', data: vsr, transformation: { width: 80, height: 80 }, altText: { title: 'The Village Star-Revue', description: 'The Village Star-Revue logo', name: 'VSR' } }));
  return runs.length ? [new Paragraph({ alignment: AlignmentType.RIGHT, children: runs })] : [];
}
